import React from "react";
import ReactQuill, { Quill } from "react-quill";
import { css } from "emotion";

const Size = Quill.import("attributors/style/size");
Size.whitelist = [false, "10px", "12px", "14px", "16px", "18px", "24px", "32px", "48px"];
Quill.register(Size, true);

const sizeStyle = document.createElement("style");
sizeStyle.innerHTML = `
  .ql-snow .ql-picker.ql-size .ql-picker-label[data-value]::before,
  .ql-snow .ql-picker.ql-size .ql-picker-item[data-value]::before {
    content: attr(data-value) !important;
  }
  .ql-snow .ql-picker.ql-size .ql-picker-label:not([data-value])::before,
  .ql-snow .ql-picker.ql-size .ql-picker-item:not([data-value])::before {
    content: '14px' !important;
  }
`;
document.head.appendChild(sizeStyle);

const colors = [
  "#000000", "#434343", "#666666", "#999999", "#cccccc", "#ffffff",
  "#ff0000", "#ff4500", "#ff9900", "#ffff00", "#00ff00", "#00ffff",
  "#0000ff", "#9900ff", "#ff00ff", "#f4cccc", "#fce5cd", "#fff2cc",
  "#d9ead3", "#d0e0e3", "#cfe2f3", "#d9d2e9", "#ead1dc", "#cc0000",
  "#e69138", "#f1c232", "#6aa84f", "#45818e", "#3d85c8", "#674ea7",
  "#a64d79", "#1f2b5e", "#00b8d4",
];

const modules = {
  toolbar: [
    [{ size: [false, "10px", "12px", "14px", "16px", "18px", "24px", "32px", "48px"] }],
    ["bold", "italic", "underline", "strike"],
    [{ color: colors }, { background: ["transparent", ...colors] }],
    [{ list: "ordered" }, { list: "bullet" }],
    ["clean"],
  ],
};

export default function RichTextEditor({ value, onChange, error, minHeight = 192 }) {
  return (
    <ReactQuill
      theme="snow"
      modules={modules}
      value={value || ""}
      onChange={onChange}
      className={css({
        "& .ql-editor": { minHeight },
        ...(error ? { border: "1px solid #e0b4b4", borderRadius: 4 } : {}),
      })}
    />
  );
}
